import brandPortalOrdersbrandOrderToken from "@faire/web-api/routes/brand-portal/orders/brandOrderToken";
import brandPortalOrdersbrandOrderTokenOrderInvoice from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/order-invoice";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var InvoiceDetailsIA = function InvoiceDetailsIA(_ref) {
  var isAusOrEurBrand = _ref.isAusOrEurBrand,
    brandOrderToken = _ref.brandOrderToken;
  if (isAusOrEurBrand && brandOrderToken) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "+HEyjw",
      defaultMessage: [{
        "type": 0,
        "value": "Iremos fornecer-lhe a fatura de qualquer encomenda que receber na Faire. As faturas serão finalizadas assim que a encomenda tiver sido enviada. Para encontrar uma fatura de encomenda, aceda a "
      }, {
        "children": [{
          "type": 0,
          "value": "Encomendas"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": ", navegue até à "
      }, {
        "children": [{
          "type": 0,
          "value": "página de informações da encomenda"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": " específica e selecione Fatura da encomenda."
      }],
      values: {
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          return _OrderLinkFormatting(chunks, brandOrderToken);
        },
        InvoiceLinkFormatting: function InvoiceLinkFormatting(chunks) {
          return invoiceLinkFormatting(chunks, brandOrderToken);
        }
      }
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "RFmrRL",
      defaultMessage: [{
        "type": 0,
        "value": "Não receberá faturas de encomendas. No entanto, pode consultar o seu resumo de pagamentos na "
      }, {
        "children": [{
          "type": 0,
          "value": "página de informações da encomenda"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": " e gerar a sua própria fatura com base nas informações fornecidas. Se optar por criar a sua própria fatura, lembre-se de que é apenas para uso interno e não deve ser enviada para a Faire ou para qualquer revendedor."
      }],
      values: {
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          return _OrderLinkFormatting(chunks, brandOrderToken);
        }
      }
    })));
  }
};
var _OrderLinkFormatting = function _OrderLinkFormatting(chunks, brandOrderToken) {
  if (!brandOrderToken) {
    return /*#__PURE__*/React.createElement(Bold, null, chunks);
  } else {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: brandPortalOrdersbrandOrderToken(brandOrderToken),
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Bold, null, chunks));
  }
};
var invoiceLinkFormatting = function invoiceLinkFormatting(chunks, brandOrderToken) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrdersbrandOrderTokenOrderInvoice(brandOrderToken),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};